import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import {
  deleteTopicsApiCrud,
  type DeleteTopicsRequest,
} from "@/generated/fastapi";

export async function deleteTopics(
  accessToken: string | null | undefined,
  request: DeleteTopicsRequest,
): Promise<boolean> {
  try {
    const response = await deleteTopicsApiCrud({
      client: browserFastApiClient,
      auth: requireFastApiAccessToken(accessToken),
      body: request,
    });

    if (response.status !== 200) {
      console.error("Failed to delete Identified Topics");
      return false;
    }

    return true;
  } catch (error) {
    console.error("Error deleting Identified Topics:", error);
    return false;
  }
}
